export enum Selects {
  select_option = 'select-option',
  agree = 'agree',
  discard = 'discard',
}

export enum CampaignStatus {
  PENDING_APPROVAL = 'pending_approval',
  AWAITING_REVIEW = 'awaiting_review',

  APPROVED = 'approved',
  PENDING = 'pending',

  SCHEDULED = 'scheduled',

  RUNNING = 'running',
  INPROCESS = 'in_process',

  PAYMENT_PENDING = 'payment_pending',

  ENDED = 'ended',
  FINISHED = 'finished',

  CANCELED = 'canceled',
  STOPPED = 'stopped',
}

export enum Roles {
  artist = 'artist',
  curator = 'curator',
  influencer = 'influencer',
  admin = 'admin',
}

export enum VideoStatus {
  ACCEPTED = 'accepted',
  CANCELED_BY_ARTIST = 'canceled_by_artist',
  APPROVED_BY_ARTIST = 'approved_by_artist',
  APPROVED_AUTOMATICALLY = 'approved_automatically',
  APPROVED_BY_ADMIN = 'approved_by_admin',
  CANCELED = 'canceled',
  AWAITING_REVIEW = 'awaiting_review',
  DECLINED = 'declined',
  AWAITING_MODERATOR_REVIEW = 'awaiting_moderator_review',
}

export enum PaymentMethodEnum {
  Stripe = 'Stripe',
  PayPal = 'PayPal',
}

export enum PaymentStatusEnum {
  PAYED = 'payed',
  COMPLETED = 'completed',
  CHARGED_BACK = 'charged-back',
}
